import { render, staticRenderFns } from "./UrunDetay.vue?vue&type=template&id=4927eace&scoped=true&"
import script from "./UrunDetay.vue?vue&type=script&lang=js&"
export * from "./UrunDetay.vue?vue&type=script&lang=js&"
import style0 from "./UrunDetay.vue?vue&type=style&index=0&id=4927eace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927eace",
  null
  
)

export default component.exports